__webpack_require__.p = "/GPT_invest/";